import { format } from 'date-fns';

type Props = {
  timestamp: string;
};

export const TimestampItem = ({ timestamp }: Props) => {
  const formattedDate = format(new Date(timestamp), 'EEEE d, MMMM');

  return (
    <li key={timestamp} className="text-foreground-subtle text-sm text-center">
      <span>{formattedDate}</span>
    </li>
  );
};
